export enum LanguageEnum {
  Korean = 'ko',
  English = 'en',
}

export type LocalizedBannerStrings = {
  textContent: {
    id: string;
    mainText: string;
    subText: string;
    link: string;
  }[];
  buttonText: string;
};

export const LOCALIZED_BANNER_STRINGS: Record<LanguageEnum, LocalizedBannerStrings> = {
  [LanguageEnum.English]: {
    textContent: [
      {
        id: '17804_A_Eng',
        mainText: 'Build your global IP strategy',
        subText: 'with MarqFolio',
        link: 'https://folio.marqvision.com/?utm_source=commerce',
      },
      {
        id: '17804_B_Eng',
        mainText: 'Revolutionary IP management.',
        subText: 'Do it all with MarqFolio.',
        link: 'https://folio.marqvision.com/?utm_source=commerce',
      },
    ],
    buttonText: 'Consult Now',
  },
  [LanguageEnum.Korean]: {
    textContent: [
      {
        id: '17804_A_Kor',
        mainText: '글로벌 브랜드 보호 전략,',
        subText: '마크폴리오와 함께 시작하세요',
        link: 'https://folio.marqvision.com/ko/?utm_source=commerce',
      },
      {
        id: '17804_B_Kor',
        mainText: '브랜드 관리의 기준을 새롭게.',
        subText: '마크폴리오로 관리해보세요.',
        link: 'https://folio.marqvision.com/ko/?utm_source=commerce',
      },
    ],
    buttonText: '상담 받기',
  },
};
